/**
 * @generated SignedSource<<6e2905979412418b1184a41593a1d9c9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type ProjectCapabilitiesQuery$variables = {
  containerId: string;
  isM3GroupPermsEnabled: boolean;
};
export type ProjectCapabilitiesQuery$data = {
  readonly projects_capabilities_extension?: {
    readonly canCreateProject_extension: boolean | null | undefined;
    readonly canExportProjects_extension: boolean | null | undefined;
  } | null | undefined;
};
export type ProjectCapabilitiesQuery = {
  response: ProjectCapabilitiesQuery$data;
  variables: ProjectCapabilitiesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "containerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isM3GroupPermsEnabled"
  }
],
v1 = [
  {
    "condition": "isM3GroupPermsEnabled",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "containerId",
                "variableName": "containerId"
              }
            ],
            "concreteType": "TownsquareProjectAppCapabilities",
            "kind": "LinkedField",
            "name": "projects_capabilities_extension",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canCreateProject_extension"
              },
              {
                "kind": "ScalarField",
                "name": "canExportProjects_extension"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ProjectCapabilitiesQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectCapabilitiesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b1e026994ed1d01cfa8e9e8b03e0be04",
    "id": null,
    "metadata": {},
    "name": "ProjectCapabilitiesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f941e247ecb40c1835a8fb3173b06034";

export default node;
